<p>debug works!</p>

<div *ngIf="haveUserFromCookie === true">
    user via controller: {{user.user_name}}

</div>
have user from cookie: {{haveUserFromCookie}}

<div *ngIf="user != null">
    user nicht mehr null {{user.hasOwnProperty('user_id')}}
    <div *ngIf="user.hasOwnProperty('user_id') === true">
        user id: {{user.user_id}} gehört: {{user_name}}
    </div>
    <div *ngIf="user.user_id != -1">
        bla {{user}} {{user.user_id}}
    </div>
</div>
<div *ngIf="user == null">
    user ist null
</div>

{{user?.user_name}}

{{user_name}}


<!--<div *ngIf="userService.haveValidUserInService() === true">-->
    <!--user via service directly: {{userService.getUserForComponent().user_name}}-->
<!--</div>-->



<!--<div *ngIf="user != null">-->
<!--<div *ngIf="userService.haveValidUserInService() != null">-->
    <!--<button (click)="userService.logOut()">logout</button>-->
<!--</div>-->


<!--<div>-->
    <!--<button (click)="getUserFromService()">getUserFromService</button>-->
<!--</div>-->

<!--<div>-->
    <!--{{userService.haveUserInService()}}-->
<!--</div>-->

<!--<div>-->
    <!--{{userService.getUserFromService().user_name}}-->
<!--</div>-->

<div>
    {{bla}}
    <input type="text" ngModel="bla">
</div>